(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["northstar"] = factory();
	else
		root["northstar"] = factory();
})(this, function() {
return webpackJsonpnorthstar([1],{

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (hp) {
  if ((hp.isIE8 || hp.isIE9 || hp.isIE10) && !hp.utils.getCookieByName('outdatedBrowserWarning')) {
    hp.utils.setCookie('outdatedBrowserWarning', 'shown');
    window.alert('We’ve noticed you’re using an outdated web browser. That means things on our site won’t look right. And after January 1, 2018, things won’t display at all. What’s the fix? Get the current version of Internet Explorer or Chrome.');
  }
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  /**
   *  cmsIconFix()
   *  Strips out CMS auto generated non-breaking
   *  space on icons (no external library required).
   */
  (0, _jquery2.default)('.glyphicon, .icon, .ns-i').each(function () {
    var elem = (0, _jquery2.default)(this);
    elem.html(elem.html().replace(/&nbsp;/g, ''));
  });
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	var pdf = ':not([href$=".pdf"])',
	    hp = ':not([href^="http://healthpartners"])',
	    hpWww = ':not([href^="http://www.healthpartners"])',
	    hpHttps = ':not([href^="https://healthpartners"])',
	    hpHttpsWww = ':not([href^="https://www.healthpartners"])',
	    vw = ':not([href^="http://virtuwell"])',
	    vwWww = ':not([href^="http://www.virtuwell"])',
	    vwHttps = ':not([href^="https://virtuwell"])',
	    vwHttpsWww = ':not([href^="https://www.virtuwell"])',
	    r = ':not([href^="http://regionshospital"])',
	    rWww = ':not([href^="http://www.regionshospital"])',
	    rHttps = ':not([href^="https://regionshospital"])',
	    rHttpsWww = ':not([href^="https://www.regionshospital"])',
	    pn = ':not([href^="http://parknicollet"])',
	    pnWww = ':not([href^="http://www.parknicollet"])',
	    pnHttps = ':not([href^="https://parknicollet"])',
	    pnHttpsWww = ':not([href^="https://www.parknicollet"])',
	    hw = ':not([href^="http://healthwise"])',
	    hwWww = ':not([href^="http://www.healthwise"])',
	    hwHttps = ':not([href^="https://healthwise"])',
	    hwHttpsWww = ':not([href^="https://www.healthwise"])',
	    ix = ':not([href^="http://ixconversations.healthwise"])',
	    ixWww = ':not([href^="http://www.ixconversations.healthwise"])',
	    ixHttps = ':not([href^="https://ixconversations.healthwise"])',
	    ixHttpsWww = ':not([href^="https://www.ixconversations.healthwise"])',
	    shp = ':not([href^="http://surveys.healthpartners"])',
	    shpWww = ':not([href^="http://www.surveys.healthpartners"])',
	    shpHttps = ':not([href^="https://surveys.healthpartners"])',
	    shpHttpsWww = ':not([href^="https://www.surveys.healthpartners"])',
	    amc = ':not([href^="http://amerymedicalcenter"])',
	    amcWww = ':not([href^="http://www.amerymedicalcenter"])',
	    amcHttps = ':not([href^="https://amerymedicalcenter"])',
	    amcHttpsWww = ':not([href^="https://www.amerymedicalcenter"])',
	    hh = ':not([href^="http://hudsonhospital"])',
	    hhWww = ':not([href^="http://www.hudsonhospital"])',
	    hhHttps = ':not([href^="https://hudsonhospital"])',
	    hhHttpsWww = ':not([href^="https://www.hudsonhospital"])',
	    lv = ':not([href^="http://lakeviewhealth"])',
	    lvWww = ':not([href^="http://www.lakeviewhealth"])',
	    lvHttps = ':not([href^="https://lakeviewhealth"])',
	    lvHttpsWww = ':not([href^="https://www.lakeviewhealth"])',
	    pnbc = ':not([href^="http://pnbconline"])',
	    pnbcWww = ':not([href^="http://www.pnbconline"])',
	    pnbcHttps = ':not([href^="https://pnbconline"])',
	    pnbcHttpsWww = ':not([href^="https://www.pnbconline"])',
	    tria = ':not([href^="http://tria"])',
	    triaWww = ':not([href^="http://www.tria"])',
	    triaHttps = ':not([href^="https://tria"])',
	    triaHttpsWww = ':not([href^="https://www.tria"])',
	    wfh = ':not([href^="http://westfieldshospital"])',
	    wfhWww = ':not([href^="http://www.westfieldshospital"])',
	    wfhHttps = ':not([href^="https://westfieldshospital"])',
	    wfhHttpsWww = ':not([href^="https://www.westfieldshospital"])',
	    cp = ':not([href^="http://cosmetic-plasticsurgeons"])',
	    cpWww = ':not([href^="http://www.cosmetic-plasticsurgeons"])',
	    cpHttps = ':not([href^="https://cosmetic-plasticsurgeons"])',
	    cpHttpsWww = ':not([href^="https://www.cosmetic-plasticsurgeons"])',
	    hwr = ':not([href^="http://hwrxic.healthwise.net/?client=healthpartners"])',
	    hwrWww = ':not([href^="http://www.hwrxic.healthwise.net/?client=healthpartners"])',
	    hwrHttps = ':not([href^="https://hwrxic.healthwise.net/?client=healthpartners"])',
	    hwrHttpsWww = ':not([href^="https://www.hwrxic.healthwise.net/?client=healthpartners"])',
	    dfp = ':not([href^="http://dresnerfacialplasticsurgery"])',
	    dfpWww = ':not([href^="http://www.dresnerfacialplasticsurgery"])',
	    dfpHttps = ':not([href^="https://dresnerfacialplasticsurgery"])',
	    dfpHttpsWww = ':not([href^="https://www.dresnerfacialplasticsurgery"])',
	    mvhp = ':not([href^="http://myvoicehealthpartners.com/Portal/default"])',
	    mvhpWww = ':not([href^="http://www.myvoicehealthpartners.com/Portal/default"])',
	    mvhpHttps = ':not([href^="https://myvoicehealthpartners.com/Portal/default"])',
	    mvhpHttpsWww = ':not([href^="https://www.myvoicehealthpartners.com/Portal/default"])',
	    ohpe = ':not([href^="http://healthpartnersohpe"])',
	    ohpeWww = ':not([href^="http://www.healthpartnersohpe"])',
	    ohpeHttps = ':not([href^="https://healthpartnersohpe"])',
	    ohpeHttpsWww = ':not([href^="https://www.healthpartnersohpe"])',
	    hphm = ':not([href^="http://hphealthmatters"])',
	    hphmWww = ':not([href^="http://www.hphealthmatters"])',
	    hphmHttps = ':not([href^="https://hphealthmatters"])',
	    hphmHttpsWww = ':not([href^="https://www.hphealthmatters"])',
	    tw = ':not([href^="https://www.twitter"])',
	    fb = ':not([href^="https://www.facebook"])',
	    yt = ':not([href^="https://www.youtube"])',
	    ig = ':not([href^="https://instagram.com/healthpartners"])',
	    httpQuery = 'a[href^="http://"]' + pdf + hp + hpWww + vw + vwWww + r + rWww + pn + pnWww + hw + hwWww + ix + ixWww + shp + shpWww + amc + amcWww + hh + hhWww + lv + lvWww + pnbc + pnbcWww + tria + triaWww + wfh + wfhWww + cp + cpWww + hwr + hwrWww + dfp + dfpWww + mvhp + mvhpWww + ohpe + ohpeWww + hphm + hphmWww,
	    httpsQuery = 'a[href^="https://"]' + pdf + hpHttps + hpHttpsWww + vwHttps + vwHttpsWww + rHttps + rHttpsWww + pnHttps + pnHttpsWww + hwHttps + hwHttpsWww + ixHttps + ixHttpsWww + shpHttps + shpHttpsWww + amcHttps + amcHttpsWww + hhHttps + hhHttpsWww + lvHttps + lvHttpsWww + pnbcHttps + pnbcHttpsWww + triaHttps + triaHttpsWww + wfhHttps + wfhHttpsWww + cpHttps + cpHttpsWww + hwrHttps + hwrHttpsWww + dfpHttps + dfpHttpsWww + mvhpHttps + mvhpHttpsWww + ohpeHttps + ohpeHttpsWww + hphmHttps + hphmHttpsWww + tw + fb + yt + ig;
	(0, _jquery2.default)(httpQuery + ', ' + httpsQuery).addClass('external-link');
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  mobileNav();
  desktopNav();
  backTop();
  mobilePagination();
  mobileSearchToggle();
  mobileLogonToggle();
  mobileAppBanner();
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppBanner = function mobileAppBanner() {
  if (_jquery2.default.smartbanner !== undefined) {
    _jquery2.default.smartbanner({
      appendToSelector: '#main-nav',
      title: 'myHP',
      icon: '/ucm/groups/public/@hp/@public/documents/images/android-touch-icon.png',
      daysHidden: 15,
      daysReminder: 90
    });
  }
},
    mobileSearchToggle = function mobileSearchToggle() {
  (0, _jquery2.default)('.search-toggle').on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)('#mobile-header, #mobile-header-search').slideToggle('fast');
  });
},
    mobileLogonToggle = function mobileLogonToggle() {
  (0, _jquery2.default)('#mobile-logon').on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)('.logon-block').addClass('active');
    (0, _jquery2.default)('#logon-drawer').slideDown('fast');
  });

  (0, _jquery2.default)('.close-logon').on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)('.logon-block').removeClass('active');
    (0, _jquery2.default)('#logon-drawer').slideUp('fast');
  });

  (0, _jquery2.default)('.mobile-logon-toggle').on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)('#mobile-logon-btn, .logon-box').toggle();
  });
},
    mobileNav = function mobileNav() {
  (0, _jquery2.default)('.navbar-offcanvas').on('show.bs.offcanvas', function (e) {
    (0, _jquery2.default)('.mobile-backdrop').addClass('in');
    (0, _jquery2.default)('#mobile-button').html('X');
  });

  (0, _jquery2.default)('.navbar-offcanvas').on('hide.bs.offcanvas', function (e) {
    (0, _jquery2.default)('.mobile-backdrop').removeClass('in');
    (0, _jquery2.default)('#mobile-button').html('Menu');
  });

  //inpage navigation hide/show event
  (0, _jquery2.default)('.mobile-expand').on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)(this).toggleClass('open');
    (0, _jquery2.default)('.menu-block-wrapper, .views-widget').toggleClass('content-showing');
  });

  //GLOBAL MOBILE NAV
  (0, _jquery2.default)('.level-one > .mobile-expand-global').on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)(this).parent().siblings().removeClass('open');
    (0, _jquery2.default)(this).parent().siblings().children().removeClass('content-showing');
    (0, _jquery2.default)('.level-two .mobile-block-wrapper-two').removeClass('content-showing');
    (0, _jquery2.default)(this).parent().toggleClass('open');
    (0, _jquery2.default)(this).next('.mobile-block-wrapper').toggleClass('content-showing');
  });

  //get the url full path and check to see if any anchor tags match it. If so add the active trail class.
  var full_path = location.href.split('#')[0];
  (0, _jquery2.default)('.menu li a').each(function () {
    var el = (0, _jquery2.default)(this);
    if (el.prop('href').split('#')[0] === full_path || el.prop('href').split('#')[0] === full_path + 'index.html') {
      el.addClass('active-trail');
    }
  });
},
    desktopNav = function desktopNav() {
  // Restore "clickable parent links" in desktop navigation
  (0, _jquery2.default)('.hovernav a').click(function () {
    window.location = this.href;
  });
},
    backTop = function backTop() {
  // browser window scroll (in pixels) after which the "back to top" link is shown
  var offset = 300,

  //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
  offset_opacity = 1200,

  //duration of the top scrolling animation (in ms)
  scroll_top_duration = 700,

  //grab the "back to top" link
  $back_to_top = (0, _jquery2.default)('.cd-top');

  //hide or show the "back to top" link
  (0, _jquery2.default)(window).scroll(function () {
    (0, _jquery2.default)(this).scrollTop() > offset ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
    if ((0, _jquery2.default)(this).scrollTop() > offset_opacity) {
      $back_to_top.addClass('cd-fade-out');
    }
  });

  //smooth scroll to top
  $back_to_top.on('click', function (event) {
    event.preventDefault();
    (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, 500);
    (0, _jquery2.default)('.navbar-brand').trigger('focus');
  });
},
    mobilePagination = function mobilePagination() {
  (0, _jquery2.default)('.pagination-responsive').each(function () {
    var listItems = (0, _jquery2.default)(this).children();
    if (listItems.length % 2 === 0) {
      (0, _jquery2.default)(this).addClass('even');
    } else {
      (0, _jquery2.default)(this).addClass('odd');
    }
  });
};

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if ((0, _jquery2.default)('.robin-nav').length > 0) {
    // Styles the nav parent folder that the user is viewing
    (0, _jquery2.default)('a').each(function () {
      if ((0, _jquery2.default)(this).prop('href') == window.location.href) {
        (0, _jquery2.default)(this).addClass('current');
      }
    });
  }
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var states = [];
  if ((0, _jquery2.default)('#state-select').length > 0) {
    _jquery2.default.getJSON('/febassets/global/data/plan-finder.json', function (statesData) {
      states = statesData;
      _jquery2.default.each(states, function (i, state) {
        (0, _jquery2.default)('#state-select').append("<option value ='" + state.key + "'>" + state.name + '</option>');
      });
    });
    (0, _jquery2.default)('#state-select').change(function () {
      var selected = (0, _jquery2.default)(this).val();
      (0, _jquery2.default)('#county-select').removeAttr('disabled');
      (0, _jquery2.default)('#plan-url').attr('disabled', true);
      (0, _jquery2.default)('#plan-url').addClass('disabled');
      (0, _jquery2.default)('#county-select').find('option').remove();
      (0, _jquery2.default)('#county-select').append("<option value=''>-Select-</option>");
      var counties = _.find(states, function (state) {
        return state.key === selected;
      }).counties;
      _jquery2.default.each(counties, function (i, county) {
        (0, _jquery2.default)('#county-select').append("<option value='" + county.url + "'>" + county.county + '</option>');
      });
    });
    (0, _jquery2.default)('#county-select').change(function () {
      var selected = (0, _jquery2.default)(this).val();
      (0, _jquery2.default)('#plan-url').attr('href', selected);
      (0, _jquery2.default)('#plan-url').removeAttr('disabled');
      (0, _jquery2.default)('#plan-url').removeClass('disabled');
    });
  }
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	//map make good happen list/map toggle
	(0, _jquery2.default)('.location-toggle').on('click', function (e) {
		e.preventDefault();
		var id = (0, _jquery2.default)(this).attr('data-related');
		(0, _jquery2.default)('.view-container').each(function () {
			(0, _jquery2.default)(this).hide();
			if ((0, _jquery2.default)(this).attr('id') === id) {
				(0, _jquery2.default)(this).show();
			}
		});
	});
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(213);

var _cmsIconFix = __webpack_require__(187);

var _cmsIconFix2 = _interopRequireDefault(_cmsIconFix);

var _externalLinks = __webpack_require__(455);

var _externalLinks2 = _interopRequireDefault(_externalLinks);

var _hp = __webpack_require__(214);

var _hp2 = _interopRequireDefault(_hp);

var _hpNav = __webpack_require__(457);

var _hpNav2 = _interopRequireDefault(_hpNav);

var _makeGoodHappen = __webpack_require__(467);

var _makeGoodHappen2 = _interopRequireDefault(_makeGoodHappen);

var _planFinder = __webpack_require__(466);

var _planFinder2 = _interopRequireDefault(_planFinder);

var _navigationActive = __webpack_require__(465);

var _navigationActive2 = _interopRequireDefault(_navigationActive);

var _browserAlert = __webpack_require__(103);

var _browserAlert2 = _interopRequireDefault(_browserAlert);

__webpack_require__(470);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.hp = (0, _hp2.default)();
window.hp.nav = _hpNav2.default;

(0, _jquery2.default)(document).ready(function () {
  window.hp.nav();

  (0, _cmsIconFix2.default)();
  (0, _externalLinks2.default)();
  (0, _makeGoodHappen2.default)();
  (0, _planFinder2.default)();
  (0, _navigationActive2.default)();
  (0, _browserAlert2.default)(window.hp);
});

/***/ })

},[490]);
});


// WEBPACK FOOTER //
// hp/js/hp.js